<script>
import NewsList from "@/views/settings/news/index/_components/NewsList.vue";
import apolloMixin from "@/mixins/apollo.mixin";
import tableColumnsMixin from "@/mixins/tableColumns.mixin";
import TableColumnsSettings from "@/components/TableColumnsSettings.vue";
import { buildNewsListTableHeaders } from "@/views/settings/news/index/config/newsListTableHeaders";
import { newsListQuery } from "@/views/settings/news/index/gql/queries";
import { mapGetters } from "vuex";
import DateService from "@/services/date.service";
import i18n from "@/plugins/vue-i18n";

export default {
  name: "Index",
  components: { NewsList, TableColumnsSettings },
  mixins: [apolloMixin, tableColumnsMixin],
  data() {
    return {
      newsListData: [],
      paginationData: {},
      sorting: {
        column: "publishedAt",
        direction: "desc",
      },
      isLoading: false,
      tableColumnsId: "news-list",
    };
  },
  computed: {
    ...mapGetters("breakpoint", ["isMobileDevice"]),
    ...mapGetters("user", ["getPermission"]),

    addRoute() {
      return { name: "NewsAdd" };
    },

    tableHeaders() {
      return buildNewsListTableHeaders({
        t: (key) => this.$t(key),
      });
    },

    newsListHeaders() {
      if (!this.isTableColumnsReady) {
        return null;
      }

      return this.visibleTableHeaders;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page = parseInt(this.$route.query.page) ?? 1) {
      this.isLoading = true;

      try {
        const { newsList } = await this.$get(newsListQuery, {
          page,
          orderBy: this.sorting,
        });

        if (newsList) {
          const listData = newsList.data.map((newsListItem) => {
            const { id, name, description, isActive, publishedAt } = newsListItem;
            const status = this.getStatus(isActive);

            return {
              id,
              name,
              description,
              status,
              publishedAt: DateService.dateConverter(publishedAt),
              page: "NewsEdit",
            };
          });

          this.paginationData = newsList.paginatorInfo;
          this.newsListData = listData;
        }
      } finally {
        this.isLoading = false;
      }
    },

    onClickRow(id) {
      this.$router.push({ name: "NewsEdit", params: { id } });
    },

    getStatus(status) {
      if (status) {
        return {
          text: i18n.t("news.status.published"),
          color: "green",
        };
      } else {
        return {
          text: i18n.t("news.status.notPublished"),
          color: "red",
        };
      }
    },
  },
};
</script>

<template>
  <OurPage :title="$t('title.news._')">
    <NewsList
      :items="newsListData"
      :headers="newsListHeaders"
      :pagination-data="paginationData"
      :is-loading="isLoading"
      @pageChange="getData"
      @onClickRow="onClickRow"
    />
    <template #header-right>
      <div class="buttons">
        <TableColumnsSettings
          v-if="!isMobileDevice && isTableColumnsReady"
          :headers="tableHeaders"
          :table-key="tablePreferenceKey"
          data-cy="news-list-columns"
        />

        <OurLink v-if="getPermission['news.create']" :route="addRoute">
          <OurButton :text="$t('button.add')" />
        </OurLink>
      </div>
    </template>
  </OurPage>
</template>

<style scoped lang="postcss">
.buttons {
  @apply flex items-center gap-4;
}
</style>
